<template>
  <div>
    <StepHeader
      :title="title"
    />

    <StepContent
      width="xl"
    >
      <AppButtonList
        value-key="value"
        :columns="3"
        :buttons="buttons"
        :value="source_of_income"
        @input="handleClick($event)"
      />
    </StepContent>

    <StepFooter>
      <AppButtonContinue
        v-data-layer="handleDataLayer"
        @click="$emit('next')"
      >
        Continue
      </AppButtonContinue>

      <StepTooltip>
        Your employment status will help determine the best vehicle and financing options for you.
      </StepTooltip>
    </StepFooter>
  </div>
</template>

<script>
import AppButtonContinue from '@/components/common/buttons/AppButtonContinue'
import AppButtonList from '@/components/common/buttons/AppButtonList'
import StepContent from '@/components/common/step/StepContent'
import StepFooter from '@/components/common/step/StepFooter'
import StepHeader from '@/components/common/step/StepHeader'
import StepTooltip from '@/components/common/step/StepTooltip'
import DataLayer from '../../../../data-layer'

export default {
  // Name
  name: 'employment-status',

  // Components
  components: {
    AppButtonContinue,
    AppButtonList,
    StepContent,
    StepFooter,
    StepHeader,
    StepTooltip
  },

  // Data
  data () {
    return {
      datalayerStepName: 'cosigner_emp_status',
      fieldName: 'source_of_income',
      datalayerList: undefined,
      defaultSelected: false,
      title: 'What Is Your Employment Status?',
      buttons: [{
        text: 'Employed',
        value: 'Employed',
        isEmployed: true,
        datalayer: 'employed'
      }, {
        text: 'Self-Employed',
        value: 'Self-Employed',
        isEmployed: true,
        datalayer: 'selfemp'
      }, {
        text: 'Student',
        value: 'Student',
        isEmployed: true,
        datalayer: 'student'
      }, {
        text: 'Retired / Pension',
        value: 'Retired/Pension',
        isEmployed: false,
        datalayer: 'retired'
      }, {
        text: 'Long Term Disability',
        value: 'Long Term Disability',
        isEmployed: false,
        datalayer: 'longdisability'
      }, {
        text: 'Other',
        value: 'Other',
        isEmployed: false,
        datalayer: 'other'
      }]
    }
  },

  // Computed
  computed: {
    source_of_income () {
      return this.$store.state.application.source_of_income_a
    },

    selectedButton () {
      if (!this[this.fieldName]) return
      for (let i in this.buttons) {
        if (this.buttons[i].value === this[this.fieldName]) {
          return this.buttons[i]
        }
      }
    }
  },

  // Created
  created () {
    if (!this[this.fieldName]) {
      this.defaultSelected = true
      this.handleUpdateValue(this.buttons[0].value)
    }
  },

  // Methods
  methods: {
    handleClick (event) {
      this.handleUpdateValue(event)
      this.$store.updateEmployment(this.selectedButton.isEmployed)
      this.defaultSelected = false
    },

    handleUpdateValue (value) {
      this.$store.updateApplication(this.fieldName, value)
      this.$store.updateApplication('source_of_income_a', value)
      this.$store.updateApplication('income_type', undefined)
      this.$store.updateApplication('income_value', undefined)
      this.$store.updateApplication('income_hours', undefined)

      if (value !== 'Other') {
        this.$store.updateApplication('company_name', '')
        this.$store.updateApplication('job_title', '')
      }
    },
    handleDataLayer () {
      DataLayer.track({
        emp_status: this.source_of_income,
        event: 'gpa_step_completed',
        is_cosigner: true,
        step: '2'
      })
    }
  }
}
</script>

<style scoped lang="scss">
</style>
